/* Smart Station redesign, review round 2: collection quick add.
   Dawn's bulk quick add shows a "- 0 +" stepper on every card. Until the item is in the cart we show a plain
   "Add to cart" button instead; clicking it presses the stepper's + button, so Dawn's own add-to-cart logic
   runs unchanged. Once the quantity is above 0 the stepper is shown again. */
(function(){
  function input(host){ return host.querySelector('quantity-input input'); }

  function qty(host){
    var i = input(host);
    if (!i || i.disabled || host.classList.contains('hidden')) return null;
    return parseInt(i.value, 10) || 0;
  }

  function label(host){
    var card = host.closest('.card-wrapper, .card, li');
    var a = card && card.querySelector('.card__heading a');
    var name = a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
    return name ? 'Add ' + name + ' to cart' : 'Add to cart';
  }

  function sync(host){
    var q = qty(host);
    var btn = host.nextElementSibling;
    var hasBtn = btn && btn.classList && btn.classList.contains('ss-qa-add');
    if (q === null) { host.dataset.ssEmpty = '0'; return; }
    if (!hasBtn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-btn ss-btn--outline ss-qa-add';
      btn.textContent = 'Add to cart';
      btn.setAttribute('aria-label', label(host));
      btn.addEventListener('click', function(){
        var plus = host.querySelector('button[name="plus"]');
        if (!plus) return;
        host.dataset.ssEmpty = '0';
        plus.click();
        var i = input(host);
        if (i) { try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); } }
      });
      host.insertAdjacentElement('afterend', btn);
    }
    var empty = q === 0 ? '1' : '0';
    if (host.dataset.ssEmpty !== empty) host.dataset.ssEmpty = empty;
  }

  function syncAll(){
    var hosts = document.querySelectorAll('quick-add-bulk');
    for (var k = 0; k < hosts.length; k++) sync(hosts[k]);
  }

  document.addEventListener('change', function(e){
    var host = e.target && e.target.closest && e.target.closest('quick-add-bulk');
    if (host) sync(host);
  }, true);

  function init(){
    syncAll();
    var t;
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(syncAll, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Collection filters (Sep 30, Cat): search box above long filter lists (Model etc., 12+ values),
   desktop sidebar and mobile drawer. Typing hides non-matching values (all words must match,
   e.g. "13 pro"). The box's own input/change events are stopped so Dawn's filter form does not
   reload on each keystroke. After a filter is ticked Dawn re-renders the filters; the box is added
   again and keeps what was typed. */
(function(){
  var MIN_ITEMS = 12;
  var saved = {};

  function norm(s){ return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function apply(ul, q){
    q = norm(q);
    var words = q ? q.split(' ') : [];
    var items = ul.querySelectorAll(':scope > li');
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (q) {
        var label = li.querySelector('.facet-checkbox__text-label');
        var text = norm(label ? label.textContent : li.textContent);
        var match = true;
        for (var w = 0; w < words.length; w++) { if (text.indexOf(words[w]) < 0) { match = false; break; } }
        if (li.classList.contains('hidden')) { li.classList.remove('hidden'); li.setAttribute('data-ss-hid', '1'); }
        li.style.display = match ? '' : 'none';
        if (match) shown++;
      } else {
        li.style.display = '';
        if (li.getAttribute('data-ss-hid')) { li.classList.add('hidden'); li.removeAttribute('data-ss-hid'); }
      }
    }
    var panel = ul.closest('.facets__display-vertical');
    var more = panel && panel.querySelector('show-more-button');
    if (more) more.style.display = q ? 'none' : '';
    var empty = ul.nextElementSibling;
    if (empty && empty.classList.contains('ss-fsearch-empty')) empty.hidden = !(q && shown === 0);
  }

  function setup(){
    var lists = document.querySelectorAll('ul.facets__list--vertical, ul.mobile-facets__list');
    for (var i = 0; i < lists.length; i++) {
      (function(ul){
        if (ul.getAttribute('data-ss-fsearch')) return;
        if (ul.querySelectorAll(':scope > li').length < MIN_ITEMS) return;
        ul.setAttribute('data-ss-fsearch', '1');
        var d = ul.closest('details');
        var key = d ? d.id : '';

        var input = document.createElement('input');
        input.type = 'search';
        input.className = 'ss-fsearch';
        input.placeholder = 'Search, e.g. 13 Pro';
        input.setAttribute('aria-label', 'Search this filter');
        input.setAttribute('autocomplete', 'off');

        var empty = document.createElement('p');
        empty.className = 'ss-fsearch-empty';
        empty.textContent = 'No matches';
        empty.hidden = true;

        function onType(e){
          e.stopPropagation();
          saved[key] = input.value;
          apply(ul, input.value);
        }
        input.addEventListener('input', onType);
        input.addEventListener('change', onType);
        input.addEventListener('keydown', function(e){ if (e.key === 'Enter') e.preventDefault(); });

        ul.parentNode.insertBefore(input, ul);
        ul.parentNode.insertBefore(empty, ul.nextSibling);
        if (saved[key]) { input.value = saved[key]; apply(ul, saved[key]); }
      })(lists[i]);
    }
  }

  function init(){
    setup();
    var t;
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(setup, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();